import React, { ReactNode } from 'react';
import { Icons } from '../../../components/atoms/SVG';
import { StatusInfo, StatusInfoModifier, StatusInfoRole } from './partials/StatusInfo';
import { Content } from './partials/Content';
import { Message } from './partials/Message';
import { StatusInfoIcon } from './partials/StatusInfoIcon';

type StatusInfoPositiveCheck = {
  modifier?: StatusInfoModifier;
  role?: StatusInfoRole;
  message?: ReactNode;
  dataFormStatus?: 'success';
};

export function StatusInfoPositiveCheck({ modifier, message, role, dataFormStatus }: StatusInfoPositiveCheck) {
  return (
    <StatusInfo modifier={modifier} role={role} dataFormStatus={dataFormStatus}>
      <Content>
        <StatusInfoIcon icon={Icons.FEEDBACK_POSITIVE_CHECK} modifier="green" />
        <Message>{message}</Message>
      </Content>
    </StatusInfo>
  );
}
